import JSZip from "jszip";

/**
 * Download files as a ZIP archive.
 * Creates a ZIP containing all provided files and triggers a browser download.
 *
 * @param files - Array of File objects to include in the ZIP
 * @param zipName - Name for the downloaded ZIP file (default: "files.zip")
 */
export async function downloadFilesAsZip(files: File[], zipName: string = "files.zip"): Promise<void> {
  if (files.length === 0) {
    console.warn("downloadFilesAsZip: No files to download");
    return;
  }

  console.log(`📦 Creating ZIP with ${files.length} file(s)...`);

  const zip = new JSZip();

  // Add each file to the ZIP
  for (const file of files) {
    zip.file(file.name, file);
  }

  // Generate the ZIP as a blob
  const blob = await zip.generateAsync({
    type: "blob",
    compression: "DEFLATE",
    compressionOptions: { level: 6 } // Medium compression
  });

  // Create a download link and trigger download
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = zipName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the object URL
  URL.revokeObjectURL(url);

  console.log(`✅ ZIP download triggered: ${zipName} (${(blob.size / 1024 / 1024).toFixed(2)} MB)`);
}
